import React, { useState } from 'react';
import DesignCard from '../DesignCard';
import Filter from '../../Filter/Filter';
import './DesignCardFilter.scss';

const DesignCardFilter = ({
  communityProfileLink,
  partnerName
}) => {

  const [displayDesignList, setDisplayDesignList] = useState(communityProfileLink);
  const [templateType, setTemplateType] = useState('All Templates');
  const [productType, setProductType] = useState('All');

  const getFilteredData = data => {
    const { type, value } = data;
    const tempCreativeDesigns = communityProfileLink
      .filter(item => {
        const tempVal = type === 'productType' ? value : productType;
        return tempVal !== 'All' ? item?.productType?.some(i => i === tempVal) : item;
      })
      // .filter(item => {
      //   const tempVal = type === 'creativeDesignStyle' ? value : designStyle;
      //   return tempVal !== 'All' ? item?.designStyle?.some(i => i === tempVal) : item;
      // })
      .filter(item => {
        const tempVal = type === 'creativeDesignTemplateType' ? value : templateType;
        return tempVal !== 'All Templates' ? item?.designType?.some(i => i === tempVal) : item;
      });
    setDisplayDesignList(tempCreativeDesigns);
  }

  const onDesignTemplateTypeFilter = (e) => {
    const value = e;
    setTemplateType(value);
    getFilteredData({ type: 'creativeDesignTemplateType', value });
  }

  const onProductTypeFilter = (e) => {
    const value = e;
    setProductType(value);
    getFilteredData({ type: 'productType', value });
  }


  return (
    <>
      <div className="partner-modal-designs-header">
        <div className="partner-modal-designs-filters">
          <div className="partner-modal-designs-filters-details">
            <Filter
              cls='community-creative-header-event-dropdown design-card-modal'
              width={380}
              defaultSelection={'All Templates'}
              filterData={['All Templates', 'Self-inking rectangular', 'Self-inking round', 'Manual']}
              onSelect={onDesignTemplateTypeFilter}
            />
            by {partnerName}
          </div>
          <div className="partner-modal-designs-filters-content">
            Through noissue Community Design, each design below can be customized to your brand colors and specific needs. Explore this Creative's unique creations and personalize them as desired.
          </div>
        </div>
        <div className="partner-modal-designs-filters-right">
          <Filter
            cls='partner-design-list-filter'
            filterType="productType"
            title="Product"
            width={330}
            filterData={['All', 'Stamp', 'Kraft Mailer', 'Cards']}
            onSelect={onProductTypeFilter}
          />
        </div>
      </div>
      <div className="partner-modal-designs-container">
        <DesignCard isCreativeList={true} designs={displayDesignList} isModal={true} />
      </div>
    </>
  )
}

export default DesignCardFilter;